import React, { useRef } from 'react';

export default function useSearchKeyword(props: {
  inputDebounceWait?: number;
  keyword: string;
  setKeyword: React.Dispatch<React.SetStateAction<string>>;
  onChange?: (payload: string) => void;
  // 输入关键字或者点击搜索记录 进行搜索
  onSearch?: (payload: string) => Promise<void>;
  onClear?: () => void;
}) {
  const { inputDebounceWait = 800, keyword, setKeyword, onChange, onSearch, onClear } = props;

  const searchTimer = useRef<NodeJS.Timeout | null>(null);

  const handleKeywordSearch = (payload?: string) => {
    const keywordTmp = payload?.trim() || '';
    if (keyword === keywordTmp) return;
    setKeyword(keywordTmp);
    if (!keywordTmp) {
      handleKeywordClear();
      return;
    }

    onSearch?.(keywordTmp);
  };

  const handleKeywordChange = (payload?: string) => {
    if (searchTimer.current) {
      clearTimeout(searchTimer.current);
      searchTimer.current = null;
    }

    const payloadTmp = payload || '';
    setKeyword(payloadTmp);
    onChange?.(payloadTmp);

    searchTimer.current = setTimeout(() => {
      handleKeywordSearch(payloadTmp);
    }, inputDebounceWait);
  };

  const handleKeywordClear = () => {
    setKeyword('');
    onClear?.();
  };

  return {
    onKeywordSearch: handleKeywordSearch,
    onKeywordChange: handleKeywordChange,
    onKeywordClear: handleKeywordClear,
  };
}
